import React, { FC, useEffect } from 'react';
import { getTheme } from '../../../utils/getTheme';
import { Box } from '../../layout/Box';

interface PostAdCardProps {
    postIndex: number;
}

const adIds = ['R-I-10074220-1', 'R-I-10074220-2', 'R-I-10074220-3'];

export const PostAdCard: FC<PostAdCardProps> = ({ postIndex }) => {
    const id = adIds[((postIndex - 10) % 30) % 9];

    useEffect(() => {
        // @ts-ignore
        window.yaContextCb.push(() => {
            // @ts-ignore
            Ya.Context.AdvManager.render({
                blockId: id,
                renderTo: `yandex_rtb_${id}_${postIndex}`,
                darkTheme: getTheme() === 'dark',
            });
        });
    }, [id]);

    return <Box width="100%" id={`yandex_rtb_${id}_${postIndex}`} />;
};
